/**
 * Widget-level design tokens.
 *
 * For Tailwind classes, use semantic tokens directly (primary-*, neutral-*, etc.).
 * This file provides hex values for charts / SVG / canvas / AG-Charts (can't use
 * Tailwind classes). Higher-level tokens and builder functions live in chartTheme.ts.
 */

// ---------------------------------------------------------------------------
// Chart color palette — hex values matching tailwind.config.js semantic tokens
// ---------------------------------------------------------------------------

/** Default series color sequence for multi-series charts */
export const CHART_SERIES_COLORS = [
  '#3b82f6', // primary-500
  '#a855f7', // secondary-500
  '#22c55e', // success-500
  '#f59e0b', // warning-500
  '#ef4444', // danger-500
  '#71717a', // neutral-500
] as const;

/** Brighter series colors for dark backgrounds */
export const CHART_SERIES_COLORS_DARK = [
  '#60a5fa', // primary-400
  '#c084fc', // secondary-400
  '#4ade80', // success-400
  '#fbbf24', // warning-400
  '#f87171', // danger-400
  '#a1a1aa', // neutral-400
] as const;
